import React, { ReactElement } from 'react';
import { Content } from './Content';

interface LoginPageProps {}

function LoginPage({}: LoginPageProps): ReactElement {
  return <Content />;
}

export { LoginPage };
